{
  "enum": {
    "ExcDtccUtcV1NettingIndicator": {
      "CNS": "CNS",
      "EXCLUDED_FROM_CLEARING": "Excluded from Clearing",
      "EXCLUDED_FROM_NETTING": "Excluded from Netting",
      "FOREIGN_BO": "Foreign BO",
      "MULTILATERAL_NETTING": "Multilateral Netting",
      "SPECIAL_TRADE": "Special Trade",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtccUtcV1SecurityType": {
      "CALL": "Call",
      "CORPORATE": "Corporate",
      "EQUITY": "Equity",
      "ETF": "ETF",
      "FUTURE": "Future",
      "MUNICIPAL": "Municipal",
      "NARROW_BASED_FUTURE": "Narrow Based Future",
      "OTHER": "Other",
      "PUT": "Put",
      "UIT": "UIT",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtccUtcV1SettlementType": {
      "CASH": "Cash",
      "REGULAR": "Regular",
      "SELLERS_OPTION": "Sellers Option",
      "UNSPECIFIED": "Unspecified",
      "WHEN_ISSUED": "When Issued"
    },
    "ExcDtccUtcV1Side": {
      "BUY": "Buy",
      "SELL": "Sell",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtccUtcV1UtcFixSessionStatus": {
      "CONNECTING": "Connecting",
      "DISCONNECTED": "Disconnected",
      "LOGGED_ON": "Logged on",
      "STOPPED": "Stopped",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtccUtcV1UtcSequenceUpdateReason": {
      "BUMP": "Bump",
      "GAP_FILL": "Gap Fill",
      "MANUAL_SET": "Manual Set",
      "RESYNC": "Resync",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListFilterableFields": {
      "sessionId": "Session",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcDtccUtcV1UtcFixSessionEventType": {
      "configUpdated": "Config Updated",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "initiatorStarted": "Initiator Started",
      "initiatorStopped": "Initiator Stopped",
      "registered": "Registered",
      "resendRequested": "Resend Requested",
      "sequenceNumbersReset": "Sequence Numbers Reset",
      "sequenceNumbersUpdated": "Sequence Numbers Updated"
    }
  },
  "sortEnum": {
    "ExcDtccUtcV1UtcFixSessionQueryServiceUtcFixSessionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}